// extracted by mini-css-extract-plugin
export default {"activationForm":"style_activationForm__scAD2","emailInput":"style_emailInput__RWtH-","btnsWrapper":"style_btnsWrapper__U-eE4","notification":"style_notification__dmaSX"};